module.exports = __webpack_public_path__ + "static/media/CR.46b19aa9.svg";